import curry from 'curry';

/**
 * Get array of routes for CRUD resource
 * @param {Object}
 */
export default curry((i18n, resource) => {
    const t = key => {
        return i18n.t(key).toLowerCase();
    };

    return [
        {
            path: `/${t(resource)}`,
            name: resource,
            component: () => import(/* webpackChunkName: "[request]" */ `@/views/${resource}/Overview.vue`),
            meta: {
                permission: `viewAny ${resource}`,
                breadcrumbs: [
                    {
                        icon: t(`icons.${resource}`),
                        title: resource,
                        name: resource,
                    },
                ],
            },
        },
        {
            path: `/${t(resource)}/${t('create')}`,
            name: `${resource}.create`,
            component: () => import(/* webpackChunkName: "[request]" */ `@/views/${resource}/Create.vue`),
            meta: {
                permission: `create ${resource}`,
                breadcrumbs: [
                    {
                        icon: t(`icons.${resource}`),
                        title: resource,
                        name: resource,
                    },
                    {
                        title: 'create',
                        name: `${resource}.create`,
                    },
                ],
            },
        },
        {
            path: `/${t(resource)}/:id`,
            name: `${resource}.view`,
            component: () => import(/* webpackChunkName: "[request]" */ `@/views/${resource}/View.vue`),
            meta: {
                permission: `view ${resource}`,
                breadcrumbs: [
                    {
                        icon: t(`icons.${resource}`),
                        title: resource,
                        name: resource,
                    },
                    {
                        title: 'view',
                        name: `${resource}.view`,
                    },
                ],
            },
        },
        {
            path: `/${t(resource)}/:id/${t('edit')}`,
            name: `${resource}.edit`,
            component: () => import(/* webpackChunkName: "[request]" */ `@/views/${resource}/Edit.vue`),
            meta: {
                permission: `edit ${resource}`,
                breadcrumbs: [
                    {
                        icon: t(`icons.${resource}`),
                        title: resource,
                        name: resource,
                    },
                    {
                        title: 'view',
                        name: `${resource}.view`,
                    },
                    {
                        title: 'edit',
                        name: `${resource}.edit`,
                    },
                ],
            },
        },
    ];
});
